var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-quill-editor"},[_c('quill-editor',{ref:"mwQuillEditor",attrs:{"options":_vm.editorOption},model:{value:(_vm.html),callback:function ($$v) {_vm.html=$$v},expression:"html"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }